import React from 'react';
import c from 'classnames';
import s from './HorizontalLayout.scss';
const HorizontalLayout = ({ children, gap, className })=>/*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className),
        style: {
            gap: `${gap}px`
        }
    }, children);
HorizontalLayout.displayName = 'HorizontalLayout';
export default HorizontalLayout;

//# sourceMappingURL=HorizontalLayout.js.map